import type { ExtensionConfig } from '@goto/shell-common'
import { getFeatureFlag } from "../helpers/shell-helpers";

enum Flags {
  ENGAGEMENTS_VERSION = 'engagements.version'
}

enum EngagementsApps {
  WC_LOADER = 'wc-loader'
}

type EngagementsVersion = {
  [key in EngagementsApps]: string
}

const fallbackAppVersions: EngagementsVersion = {
  [EngagementsApps.WC_LOADER]: 'latest'
}

// Voluntarily without prerequisites. WC can be loaded by many extensions
// and they must have access to the commands to load them.
// WCs are loaded on demand only.
const wcLoaderExtensionConfig: ExtensionConfig = {
  id: '@dce/engagements-web-components-loader-extension',
  get url() {
    const version = getFeatureFlag<EngagementsVersion>(Flags.ENGAGEMENTS_VERSION, fallbackAppVersions)?.["wc-loader"] ?? fallbackAppVersions?.["wc-loader"]
    return new URL(`/experiences/engagements/wc-loader/${version}/extension.mjs`, location.origin)
  },
  esModule: true,
  integrations: {
    msTeams: {
      shouldLoadInIntegration: true,
    },
    sidePanel: {
      shouldLoad: true,
    },
  },
}

export default [wcLoaderExtensionConfig]
